
import FiftyFifty from '~/components/FiftyFifty.vue'
export default {
  components: {
    FiftyFifty,
  },
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
